<mat-progress-spinner
        class="example-margin" 
        [mode]="mode"
        [value]="value">
</mat-progress-spinner>